import React, { useState } from 'react';
import { TwitterShareButton, LineShareButton } from 'react-share';
import { quizResult, quizShareText, QUIZ_SHARE_URL } from '../utils/faithQuiz';

export default function FaithQuizResult({ score, total, review = false }) {
  const { percent, faithIndex, rank } = quizResult(score, total);
  const shareText = quizShareText(score, total, review);
  const fullText = `${shareText}\n${QUIZ_SHARE_URL}`;
  const [status, setStatus] = useState('');
  const [manualCopy, setManualCopy] = useState(false);
  const [sharing, setSharing] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(fullText);
      setStatus('結果をコピーしました。');
      setManualCopy(false);
    } catch {
      setStatus('下の文章を選択してコピーしてください。');
      setManualCopy(true);
    }
  }

  async function share() {
    setSharing(true);
    setStatus('');
    try {
      await navigator.share({ title: '信仰クイズ', text: shareText, url: QUIZ_SHARE_URL });
    } catch (error) {
      if (error.name !== 'AbortError') {
        setStatus('共有を開けませんでした。X・LINE、または結果のコピーをお使いください。');
      }
    } finally {
      setSharing(false);
    }
  }

  return <div className="faith-quiz-result">
    {review && <p className="reformation-quiz__note">復習の結果</p>}
    <div className="faith-quiz-result__summary">
      <div className="faith-quiz-result__rating">
        <p>あなたの信仰偏差値は…</p>
        <strong className="faith-quiz-result__index">{faithIndex}</strong>
        <span className={`faith-quiz-result__rank faith-quiz-result__rank--${rank.toLowerCase()}`}>ランク{rank}</span>
        <p className="reformation-quiz__note">正答率から算出したクイズ内の目安</p>
      </div>
      <figure className="faith-quiz-result__chart">
        <svg viewBox="0 0 200 200" role="img" aria-label={`${total}問中${score}問正解、正答率${percent}%`}>
          <circle cx="100" cy="100" r="80" fill="none" stroke="#51475e" strokeWidth="18" />
          <circle cx="100" cy="100" r="80" fill="none" stroke="#edcb88" strokeWidth="18"
            pathLength="100" strokeDasharray={`${percent} ${100 - percent}`} transform="rotate(-90 100 100)" />
          <text x="100" y="97" textAnchor="middle" fill="#fff8eb" fontSize="36" fontWeight="700">{score} / {total}</text>
          <text x="100" y="127" textAnchor="middle" fill="#edcb88" fontSize="16">正解</text>
        </svg>
        <figcaption>正解 {score}問 · 不正解 {total - score}問</figcaption>
      </figure>
    </div>
    <details className="reformation-quiz__note">
      <summary>ランクと数値について</summary>
      <p>A：正答率80%以上 ／ B：50%以上 ／ C：50%未満。</p>
      <p>「信仰偏差値」は統計上の偏差値ではなく、正答率を30〜70に換算したクイズ用の数値です。信仰の深さを評価するものではありません。</p>
    </details>
    <div className="faith-quiz-result__share" aria-label="結果の共有">
      <TwitterShareButton url={QUIZ_SHARE_URL} title={shareText} resetButtonStyle={false}>Xで共有</TwitterShareButton>
      <LineShareButton url={QUIZ_SHARE_URL} title={shareText} resetButtonStyle={false}>LINEで共有</LineShareButton>
      {typeof navigator.share === 'function' && <button onClick={share} disabled={sharing}>その他のSNSに共有</button>}
      <button onClick={copy}>結果をコピー</button>
    </div>
    <p role="status" className="reformation-quiz__note">{status}</p>
    {manualCopy && <label className="faith-quiz-result__copy">共有する文章
      <textarea readOnly value={fullText} onFocus={event => event.target.select()} rows={5} />
    </label>}
  </div>;
}
